<template>
  <div class="CSChatThai" >
    <Navbar/>
    <div class="CSChatThai hidden-sm-and-down"  style="width: 100%; height: 100vh; align-content: center; background-color: white;">
      <v-card flat tile class="lighten-1 white--text text-xs-center" id="contact" >
        <v-layout  justify-center  align-center>
          <v-flex xs12 sm4 offset-sm1  class="CSChatThai" style="margin-top: 10vh;">
            <v-layout align-center column justify-center style="height: 100%;">
            <v-card class="elevation-0 transparent" style="width: 100%" >
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">ส่งข้อความถึงเรา</div>
              </v-card-title>
                <input type="text" placeholder="ชื่อ" class="InputEdit" v-model="name">
                <br/><br/>
                <!-- <input type="text" placeholder="ที่อยู่อีเมล" class="InputEdit" v-model="email">
                <br/><br/>
                <input type="text" placeholder="เบอร์โทรศัพท์" class="InputEdit" v-model="phone">
                <br/><br/> -->
                <v-text-field
                  label="อีเมล"
                  v-model="email"
                  :rules="emailRules"
                  single-line
                  solo
                  required
                  ></v-text-field>
                <v-text-field
                  label="หมายเลขโทรศัพท์"
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  single-line
                  solo
                ></v-text-field>

                <div class="InputEdit" style="width: 100%;">
                <v-menu bottom offset-y style="width: 100%; height: 20px; margin-bottom: 7px;">
                  <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0;">
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;" v-if="!title.category_TH">หัวข้อ</p>
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;" else>{{title.category_TH}}</p>
                    <v-spacer></v-spacer>
                    <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
                  </v-btn>
                  <div style="background: white;height: 300px;">
                  <span style="padding: 5px !important;" class="CSChatThai" >รายงานปัญหา</span>
                  <v-list>
                    <v-list-tile v-for="(item, index_report) in items.list_report" :key="index_report" @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>

                  <div style="background: white;">
                  <span style="padding: 5px !important;" class="CSChatThai" >ข้อเสนอแนะ</span>
                  <v-list >
                    <v-list-tile v-for="(item, index) in items.list_feedback" :key="index" @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                </div>
                </v-menu>
              </div>
                <br/>
                <!-- <input type="text" placeholder="รายละเอียด" class="InputEdit" v-model="detail" rows="8"> -->
                <v-textarea
                  v-model="detail"
                  placeholder="รายละเอียด"
                  counter
                  maxlength="255"
                  full-width
                  single-line
                  solo
                  height="60"
                ></v-textarea>
              <!-- <br/> -->
              <form ref="fileform" style="float: left;">
                <label>
                  <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกรูปภาพ</b>
                  <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
                </label>
              </form>

              <v-flex xs12 sm12 md12 xl12 v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 12vh !important; max-width: 33vw !important; display: -webkit-inline-box; background: rgb(234, 234, 234); padding-top: 3px;" class="containers hidden-sm-and-down">
                <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
                  <a class="close-classic" @click="removeFile( key )"></a>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                    <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 5vh !important; width:5vh !important;display: flex;justify-content: center;" />
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>
              </v-flex>
              <br/>
              <v-layout row wrap align-center justify-center>
                <v-btn dark  color="blue"  @click="sendfeedback()" v-if="name !== '' && email !== '' && title !== '' && detail !== ''">
                  <span >ส่งถึงเรา</span>
                </v-btn>
                <v-btn disabled v-else>
                  <span >ส่งถึงเรา</span>
                </v-btn>
                <v-btn dark  color="blue-grey" style="color: white !important;"  @click="cancel()">
                  <span >ยกเลิก</span>
                </v-btn>
              </v-layout>
            </v-card>
          </v-layout>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1 class="CSChatThai">
            <v-card class="elevation-0 transparent" style="margin-top:7vh;">
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">บริษัท วัน เซ็นทริค จำกัด</div>
              </v-card-title>
              <v-card-media height="20vw" src="/static/img/onechat/map.png" >
            </v-card-media>
              <v-layout>
                <v-icon class="blue--text text--lighten-2">place</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  บริษัท วัน เซ็นทริค จำกัด <br>1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                  เขตห้วยขวาง กรุงเทพมหานคร 10310
                </v-card-text>
              </v-layout>
              <v-layout >
                <v-icon class="blue--text text--lighten-2">email</v-icon>
                <v-card-text class="CSChatThai maildata" style="text-align: left;">
                  <a href="mailto:onechat@one.th" class="">onechat@one.th</a>
                </v-card-text>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- footer web -->
      <!-- <div class="footer hidden-sm-and-down">
        <v-layout align-center row justify-center>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab()">API</a></b></p>
          <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>
          <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
        </v-layout>
      </div> -->
    </div>
    <!-- mobile -->
    <div class="CSChatThai hidden-md-and-up" id="contactmo">
      <v-layout row wrap justify-center background-color: white >
        <v-flex xs12 sm4>
          <v-layout align-center column justify-center style="height: 100%;">
            <v-card class="elevation-0 transparent" style="width: 100%; margin-top: 10vh;" >
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">ส่งข้อความถึงเรา</div>
              </v-card-title>
                <input type="text" placeholder="ชื่อ" class="InputEdit" v-model="name">
                <br/><br/>
                <!-- <input type="text" placeholder="ที่อยู่อีเมล" class="InputEdit" v-model="email">
                <br/><br/>
                <input type="text" placeholder="เบอร์โทรศัพท์" class="InputEdit" v-model="phone">
                <br/><br/> -->
                <v-text-field
                  label="อีเมล"
                  v-model="email"
                  :rules="emailRules"
                  single-line
                  solo
                  required
                  ></v-text-field>
                <v-text-field
                  label="หมายเลขโทรศัพท์"
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  single-line
                  solo
                ></v-text-field>

           <div class="InputEdit" style="width: 100%;">
                <v-menu bottom offset-y style="width: 100%; height: 20px; margin-bottom: 7px;">
                  <v-btn  flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0;">
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;" v-if="!title.category_TH">หัวข้อ</p>
                    <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;" else>{{title.category_TH}}</p>
                    <v-spacer></v-spacer>
                    <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
                  </v-btn>
                  <div style="background: white;height: 300px;">
                  <span style="padding: 5px !important;" class="CSChatThai" >รายงานปัญหา</span>
                  <v-list>
                    <v-list-tile v-for="(item, index_list_re) in items.list_report" :key="index_list_re" @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>

                  <div style="background: white;">
                  <span style="padding: 5px !important;" class="CSChatThai" >ข้อเสนอแนะ</span>
                  <v-list >
                    <v-list-tile v-for="(item, index_list) in items.list_feedback" :key="index_list" @click="title = item;" style="background: white;">
                      <v-list-tile-title class="CSChatThai" >{{ item.category_TH }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                </div>
                </v-menu>
              </div>
                <br/>
                <v-textarea
                  v-model="detail"
                  placeholder="รายละเอียด"
                  counter
                  maxlength="255"
                  full-width
                  single-line
                  solo
                  height="85"
                ></v-textarea>
              <br/>
              <form ref="fileformmo" style="float: left;">
                <label>
                  <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกรูปภาพ</b>
                  <input type="file" id="filesmo" ref="filesmo" multiple v-on:change="handleFilesUploadmo()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
                </label>
              </form>
              <v-flex xs12 sm12 md12 xl12 v-if="filesmo.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 30vh !important; max-width: 100% !important; display: -webkit-inline-box; background: rgb(234, 234, 234); padding-top: 3px;" class="containers hidden-md-and-up">
                <div class="borderfilemo" v-for="(file, key) in filesmo" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
                  <a class="close-classic" @click="removeFilemo( key )"></a>
                  <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                    <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 15vh !important; width:15vh !important;display: flex;justify-content: center;" />
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                  <div v-else style="text-align: center; display: grid; justify-content: center;" >
                    <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                    <b class="text2">{{ file.file.name }}</b>
                  </div>
                </div>
              </v-flex>
              <br/>
              <v-layout align-center row justify-center>
                <v-btn dark  color="blue"  @click="sendfeedbackmo()" v-if="name !== '' && email !== '' && title !== '' && detail !== ''">
                  <span >ส่งถึงเรา</span>
              </v-btn>
              <v-btn disabled v-else>
                  <span >ส่งถึงเรา</span>
              </v-btn>
                <v-btn dark  color="blue-grey" style="color: white !important;"  @click="cancel()">
                  <span >ยกเลิก</span>
                </v-btn>
              </v-layout>
            </v-card>
          </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1 class="CSChatThai">
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center" style="text-align: left;">
                <div class="headline CSChatThai">บริษัท วัน เซ็นทริค จำกัด</div>
              </v-card-title>
                <v-card-media height="65vw" src="/static/img/onechat/map.png" >
                </v-card-media>
              <v-layout>
                <v-icon class="blue--text text--lighten-2">place</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  บริษัท วัน เซ็นทริค จำกัด 1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16
                  ถ.เพชรบุรีตัดใหม่ แขวงบางกะปิ
                  เขตห้วยขวาง กรุงเทพมหานคร 10310
                </v-card-text>
              </v-layout>
              <v-layout >
                <v-icon class="blue--text text--lighten-2">email</v-icon>
                <v-card-text class="CSChatThai" style="text-align: left;">
                  <a href="mailto:onechat@one.th" class="maildata">onechat@one.th</a>
                </v-card-text>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- footer mobile -->
        <!-- <v-layout align-center column justify-center style="background-color: white !important;">
          <v-flex xs12 md12>
            <v-layout align-center row justify-center>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>
              <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black !important;"><b><a style="color: black;" @click="toNewTab()">API</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 0px;color: black !important;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
              <p class="CSChatThai" style="padding-left: 5px;color: black !important;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
          </v-flex>
            <v-flex xs12 md12>
            <p style="padding-left: 20px; padding-right: 20px;color: black !important;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
          </v-flex>
        </v-layout> -->
    </div>
</div>
</template>
<script>
  import Navbar from '@/components/home/Navbarapi'
  var _ = require('lodash')
  export default {
    components: {
      Navbar
    },
    data: () => ({
      phone: '',
      name: '',
      email: '',
      title: {},
      detail: '',
      items: [],
      files: [],
      filesmo: [],
      phoneRules: [
        v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
        v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
        v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      ],
      emailRules: [
        v => !!v || 'กรุณากรอกอีเมล์',
        v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมล์ไม่ถูกต้อง'
      ],
      webdev: process.env.WEBchatdev
      // dragAndDropCapable: false,
      // dragAndDropCapablemo: false
      // list_category: []
      // items: [
      //   { icon: 'phone', title: 'โทรศัพท์ : 0-2257-7000' },
      //   { title: 'โทรสาร : 0-2257-1379' },
      //   { title: 'ศูนย์บริการลูกค้า : 0-2257-7269' },
      //   { icon: 'email', title: 'one-platform@inet.co.th' }
      // ]
    }),
    created () {
      this.getsubject()
    },
    watch: {
      files () {
        if (this.files.length > 5) {
          this.$swal(
            '',
            'เลือกรูปภาพได้สูงสุด 5 รูป.',
            'warning'
          )
          _.pullAt(this.files, [5])
        }
      },
      filesmo () {
        if (this.filesmo.length > 5) {
          this.$swal(
            '',
            'เลือกรูปภาพได้สูงสุด 5 รูป.',
            'warning'
          )
          _.pullAt(this.filesmo, [5])
        }
      }
    },
    mounted () {
      // this.dragAndDropCapable = this.determineDragAndDropCapable()
      // if (this.dragAndDropCapable) {
      //   ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
      //     this.$refs.fileform.addEventListener(evt, function (e) {
      //       e.preventDefault()
      //       e.stopPropagation()
      //     })
      //   }.bind(this))
      //   this.$refs.fileform.addEventListener('drop', function (e) {
      //     for (let i = 0; i < e.dataTransfer.files.length; i++) {
      //       this.files.push({file: e.dataTransfer.files[i], status: 'waiting'})
      //       this.getImagePreviews()
      //     }
      //   }.bind(this))
      // }
    },
    methods: {
      sendfeedback () {
        var lengthfile = this.files.length
        if (lengthfile === 0) {
          let formData = new FormData()
          formData.append('phone', this.phone)
          formData.append('email', this.email)
          formData.append('comment', this.detail)
          formData.append('name', this.name)
          formData.append('category_id', this.title.category_id)
          this.$http.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            // console.log(response.data)
            this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
            this.cancel()
          }, () => {
            this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
          })
        } else {
          this.sendfeedbackfile()
          // for (var i = 0; i < lengthfile; i++) {
          //   this.sendfeedbackfile(i)
          // }
        }
      },
      sendfeedbackmo () {
        var lengthfile = this.filesmo.length
        if (lengthfile === 0) {
          let formData = new FormData()
          formData.append('phone', this.phone)
          formData.append('email', this.email)
          formData.append('comment', this.detail)
          formData.append('name', this.name)
          formData.append('category_id', this.title.category_id)
          this.$http.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
            // console.log(response.data)
            this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
            this.cancel()
          }, () => {
            this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
          })
        } else {
          this.sendfeedbackfilemo()
          // for (var i = 0; i < lengthfile; i++) {
          //   this.sendfeedbackfile(i)
          // }
        }
      },
      sendfeedbackfile () {
        let formData = new FormData()
        var lengthfile = this.files.length
        for (var i = 0; i < lengthfile; i++) {
          var file = this.files[i].file
          formData.append('file', file, file.name)
        }
        // console.log(formData)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.$http.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
          this.cancel()
        }, () => {
          this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
        })
      },
      sendfeedbackfilemo () {
        let formData = new FormData()
        var lengthfile = this.filesmo.length
        for (var i = 0; i < lengthfile; i++) {
          var file = this.filesmo[i].file
          formData.append('file', file, file.name)
        }
        // console.log(formData)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.$http.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', 'ส่งข้อความถึงเราสำเร็จ', 'success')
          this.cancel()
        }, () => {
          this.$swal('', 'ไม่สามารถส่งข้อความได้ กรุณาลองใหม่ภายหลัง', 'error')
        })
      },
      removeFile (key) {
        this.files.splice(key, 1)
        this.getImagePreviews(key)
      },
      removeFilemo (key) {
        this.filesmo.splice(key, 1)
        this.getImagePreviewsmo(key)
      },
      getImagePreviews (key) {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
              // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
            }.bind(this), false)
            reader.readAsDataURL(this.files[i].file)
            // this.extension(this.files[i].name)
            // console.log(this.extension())
          } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
        }
      },
      getImagePreviewsmo (key) {
        for (let i = 0; i < this.filesmo.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.filesmo[i].file.name)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.filesmo[i].file)
            // this.extension(this.files[i].name)
            // console.log(this.extension())
          } else {
            // this.$nextTick(function(){
            // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
            // });
            // console.log('mm')
          }
        }
      },
      extension (files) {
        var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
        var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
        var pdf = ['pdf']
        var file = ['ai', 'ps', 'psd']
        var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
        var presentation = ['ppt', 'pps', 'pot', 'pptx']
        var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
        var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
        var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
        if (pdf.includes(extension)) {
          return 'fas fa-file-pdf'
        } else if (archive.includes(extension)) {
          return 'fas fa-file-archive'
        } else if (spreadsheet.includes(extension)) {
          return 'fas fa-file-excel'
        } else if (presentation.includes(extension)) {
          return 'fas fa-file-powerpoint'
        } else if (word.includes(extension)) {
          return 'fas fa-file-word'
        } else if (execution.includes(extension)) {
          return 'fas fa-file-code'
        } else if (image.includes(extension)) {
          return 'fas fa-file-image'
        } else if (file.includes(extension)) {
          return 'fas fa-file'
        } else {
          return 'fas fa-file-alt'
        }
      // return extension[extension.length-1]
      },
      // determineDragAndDropCapable () {
      //   var div = document.createElement('div')
      //   return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
      // },
      handleFilesUpload (key) {
        let uploadedFiles = this.$refs.files.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviews(key)
        document.querySelector('#files').value = ''
      },
      handleFilesUploadmo (key) {
        let uploadedFiles = this.$refs.filesmo.files
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.filesmo.push({file: uploadedFiles[i], status: 'waiting'})
        }
        this.getImagePreviewsmo(key)
        document.querySelector('#filesmo').value = ''
      },
      getsubject () {
        this.$http.post(process.env.APImanage + '/getcategory').then((response) => {
          if (response.data.status === 'success') {
            console.log(response.data)
            this.items = response.data
          }
        })
      },
      cancel () {
        this.phone = ''
        this.name = ''
        this.email = ''
        this.title = {}
        this.detail = ''
        this.files = []
        this.filesmo = []
      },
      sendme () {
        this.$http.post(process.env.APImanage + '/contactus', {name: this.name, email: this.email, title: this.title.category_TH, detail: this.detail, platform: 'webportal'}).then((response) => {
          if (response.data.status === 'success') {
            this.$swal(
              'ส่งข้อความถึงเรา',
              'ส่งข้อความถึงเราสำเร็จ.',
              'success')
            this.cancel()
          }
        }, (response) => {})
      },
      linkAPI () {
        window.open('/docs', '_blank').focus()
      },
      toPage (page) {
        this.$router.push(page)
      },
      linkregister () {
        window.open('/register').focus()
      },
      linkdownload () {
        window.open('/download').focus()
      },
      toNewTab () {
        window.open(this.webdev, '_blank').focus()
      }
    }
  }
</script>
<style lang="css" scoped>
>>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea, .v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 25px;
  margin-top: 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
    }
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none;
}
>>>.v-input__slot {
  border-width: thin;
  border-style: solid;
  border-color: #d2d8dd;
  border-radius: 4px;
}
.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}
[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.containers {
  width: 576px; margin: 0 auto;
}
.containers:after {
  content: '';
  display: block;
  clear: both;
}
.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 7vw !important;
  height: 10vh !important;
  position: relative;
  background: white;
}
.borderfilemo {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 40vw !important;
  height: 25vh !important;
  position: relative;
  background: white;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
/*>>> a.maildata:link {
  color: black !important;
}*/
.sidebar_content .mail a:hover {
  color: #2562af !important;
}
/*>>> a.maildata:visited {
  color: blue !important;
}*/

a:link {
    text-decoration: none;
    color: black !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #1e88e5 !important;
    text-decoration: none;
}

a:active {
    color: black !important;
    text-decoration: none;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
 color: black;
}
.InputEdit {
    width: 100%;
    padding: 5px 15px;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.buttonedit {
      border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
    text-align: center;
    font-weight: 400 !important;
  text-transform: none;
}
>>> .v-input .v-label {
    height: 20px;
    line-height: 20px;
    font-size: 14px !important;
}
.elevation-2 {
  box-shadow: none !important;
  }
/*.footer>:first-child {
  margin-left: 0px !important;
}
.footer>:last-child {
  margin-right: 0px !important;
}*/
/*.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: black !important;
   color: white;
   text-align: center;
}*/
</style>



// WEBPACK FOOTER //
// src/components/home/Footer.vue